import { parseNumber, parseString, transformModel } from '~/src/dash/api/resource-transforms';
import { createUrlWithParam, IHttpResponse, restGet, restPost } from '~/src/dash/api/rest';
import { EBool } from '~/src/dash/api/types/bool';

export interface IS3AccessPoint {
  ID: number;
  PublisherID: number;
  BucketName: string;
  Region: string;
  FileDestination: string;
  AccessKey: string;
  SecretKey: string;
  IsAccessPointTTD: number;
}

export const transformS3AccessPoint = transformModel<IS3AccessPoint>({
  ID: parseNumber(['ID']),
  PublisherID: parseNumber(['PublisherID']),
  BucketName: parseString(['BucketName']),
  Region: parseString(['Region']),
  FileDestination: parseString(['FileDestination']),
  AccessKey: parseString(['AccessKey']),
  SecretKey: parseString(['SecretKey']),
  IsAccessPointTTD: ['IsAccessPointTTD'],
});

export async function getS3AccessPoint(
  publisherID: string,
  isS3AccessPointTTD: EBool,
): Promise<IHttpResponse<IS3AccessPoint>> {
  const reqUrl = createUrlWithParam(
    `/s3_access_point`,
    publisherID,
    String(isS3AccessPointTTD),
    'is_access_point_ttd',
  );
  return await restGet<IS3AccessPoint>(reqUrl, {});
}

export async function createOrUpdateS3AccessPoint(
  s3AccessPoint: IS3AccessPoint,
  isS3AccessPointTTD: EBool,
): Promise<IHttpResponse<IS3AccessPoint>> {
  const reqUrl = createUrlWithParam(
    '/s3_access_point',
    s3AccessPoint.PublisherID.toString(),
    isS3AccessPointTTD.toString(),
    'is_access_point_ttd',
  );
  const parsedAccessPoint = transformS3AccessPoint(s3AccessPoint);
  return await restPost<IS3AccessPoint>(reqUrl, parsedAccessPoint);
}
